import VMDetectionController from './VMDetectionController';
import VMDetectionInvigilatorModal from './VMDetectionInvigilatorModal';

export default function registerVMDetectionModule(assessmentFrontendControllers) {
    assessmentFrontendControllers
        .controller('VMDetectionController', [
            '$scope',
            'EventLogBridgeService',
            'BridgeRuntimeService',
            'LogBridgeService',
            '$uibModal',
            'VMDetectionService',
            '$location',
            VMDetectionController
        ]);

    assessmentFrontendControllers
        .service('VMDetectionInvigilatorModal', [
            '$scope',
            'EventLogBridgeService',
            'AuthenticationBridgeService',
            'LogBridgeService',
            '$timeout',
            '$signals',
            '$uibModalInstance',
            '$location',
            '$translate',
            function(
                $scope,
                EventLogBridgeService,
                AuthenticationBridgeService,
                LogBridgeService,
                $timeout,
                $signals,
                $uibModalInstance,
                $location,
                $translate
            ) {
                return new VMDetectionInvigilatorModal(
                    $scope,
                    EventLogBridgeService,
                    AuthenticationBridgeService,
                    LogBridgeService,
                    $timeout,
                    $signals,
                    $uibModalInstance,
                    $location,
                    $translate
                );
            }
        ]);
}